import {
  api_get_stage_list_url,
  api_create_stage_url,
  api_update_stage_url,
  api_activate_deactivate_stage_url,
  api_get_stage_details_url
} from "./stageApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  parser_get_stage_list,
  parser_create_stage,
  parser_update_stage,
  parser_activate_deactivate_stage,
  parser_get_stage_details
} from "./stageParser";
import { PAGE } from "../../helpers/constants";

export const get_stage_list = createAsyncThunk(
  "stage",
  async (payload) => {
    try {
      const { page, limit, qn, qs, kc } = payload;
      const response = await api_get_stage_list_url(page, limit, qn, qs, kc);
      const data = parser_get_stage_list(response);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  }
);


export const create_stage = createAsyncThunk(
  "create_stage",
  async (payload) => {
    try {
      const { stage_name, color, display_order, stage_logo, sidebar_menu_id } = payload
      const formData = new FormData();
      formData.append("stage_name", stage_name);
      formData.append("color", color);
      formData.append("display_order", display_order);
      if (sidebar_menu_id) {
        formData.append("sidebar_menu_id", sidebar_menu_id);
      }
      if (payload.stage_logo) {
        formData.append("stage_logo", stage_logo);
      }
      const response = await api_create_stage_url(formData);
      const data = parser_create_stage(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const update_stage = createAsyncThunk(
  "update_stage",
  async (payload) => {
    try {
      const { stage_id, updated_data } = payload
      const formData = new FormData();
      if (updated_data.stage_name) {
        formData.append("stage_name", updated_data.stage_name);
      }
      if (updated_data.color) {
        formData.append("color", updated_data.color);
      }
      if (updated_data.display_order) {
        formData.append("display_order", updated_data.display_order);
      }
      if (updated_data.sidebar_menu_id) {
        formData.append("sidebar_menu_id", updated_data.sidebar_menu_id);
      }
      if (updated_data.stage_logo) {
        formData.append("stage_logo", updated_data.stage_logo);
      }
      const response = await api_update_stage_url(stage_id, formData);
      const data = parser_update_stage(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const activate_deactivate_stage = createAsyncThunk(
  "activate_stage_stage",
  async (payload) => {
    try {
      const { stage_id, updated_data } = payload
      const response = await api_activate_deactivate_stage_url(stage_id, updated_data)
      const data = parser_activate_deactivate_stage(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_stage_details = createAsyncThunk(
  "get_stage_details",
  async (payload) => {
    try {
      const response = await api_get_stage_details_url(payload);
      const data = parser_get_stage_details(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

const initialState = {
  common_loading: false,
  is_stage_modal_open: false,
  selected_status: '',
  search_query: '',
  selected_data: null,
  c_action: null,
  stage_id: null,
  stage_list: [],
  total_stage_count: 0,
  active_stage: 0,
  page: PAGE - 1
};

export const stageSlice = createSlice({
  name: "stage",
  initialState,
  reducers: {
    setStagePage: (state, action) => {
      state.page = action.payload;
    },
    setStageModalOpen: (state, action) => {
      state.is_stage_modal_open = action.payload;
    },
    setAction: (state, action) => {
      state.c_action = action.payload;
    },
    setId: (state, action) => {
      state.stage_id = action.payload;
    },
    setStatus: (state, action) => {
      state.selected_status = action.payload ? action.payload : '';
    },
    setSearchQuery: (state, action) => {
      state.search_query = action.payload;
    }
  },
  extraReducers: (builder) => {
    // get process list
    builder.addCase(get_stage_list.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_stage_list.fulfilled, (state, action) => {
      state.common_loading = false;
      const stageData = Array.isArray(action.payload.stage) ? action.payload.stage : [];
      state.stage_list = stageData;
      state.total_stage_count = action.payload.total_count || stageData.length;
      state.active_stage = stageData.filter(stage => stage.is_active).length;
    })
    builder.addCase(get_stage_list.rejected, (state) => {
      state.common_loading = false;
    })
    //create process
    builder.addCase(create_stage.fulfilled, (state, action) => {
      state.common_loading = false;
      if (action.payload?.data) {
        state.stage_list.push(action.payload.data);
        state.total_stage_count = state.stage_list.length;
        state.active_stage = state.stage_list.filter(stage => stage.is_active).length;
      }
    });
    //update process
    builder.addCase(update_stage.fulfilled, (state, action) => {
      state.common_loading = false;
      state.stage_list = state.stage_list.map((stage) =>
        stage.id === action.payload.data.id ? { ...stage, ...action.payload.data } : stage
      );
      state.total_stage_count = state.stage_list.length;
      state.active_stage = state.stage_list.filter(stage => stage.is_active).length;
    });
    // activate_deactivate_process
    builder.addCase(activate_deactivate_stage.fulfilled, (state, action) => {
      state.common_loading = false;
      state.stage_list = state.stage_list.map((stage) =>
        stage.id === action.payload.data.id ? { ...stage, ...action.payload.data } : stage
      );
      state.total_stage_count = state.stage_list.length;
      state.active_stage = state.stage_list.filter(stage => stage.is_active).length;
    });
    //get process details
    builder.addCase(get_stage_details.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_stage_details.fulfilled, (state, action) => {
      state.common_loading = false;
      state.selected_data = action.payload.data
    })
    builder.addCase(get_stage_details.rejected, (state) => {
      state.common_loading = false;
    })
  },
});

// Action creators are generated for each case reducer function
export const {
  setStageModalOpen,
  setStagePage,
  setAction,
  setId,
  setStatus,
  setSearchQuery
} = stageSlice.actions;
export default stageSlice.reducer; 